/** The stored value for a record this system owns. It is the DB default and MarcJsonConverter binds behaviour to it, so it stays as it is. */
var LOCAL_SOURCE_SYSTEM = 'LOCAL';
/** What that value is called outside the code — the name of the authority file itself. */
var LOCAL_SOURCE_SYSTEM_LABEL = 'CZNA';
/**
 * One source system rendered the way a cataloguer names it: `CZNA` for our own
 * records, every other value exactly as it is stored.
 *
 * `LOCAL` is an internal value that tells a cataloguer nothing (CZNA-779). Only the
 * display changes — the stored value stays `LOCAL` everywhere, including the
 * `sourceSystem` query parameter this module sends when filtering, so this must never
 * be applied to a filter option's `value`.
 *
 * Shared by the authority list (the "Zdrojový systém" filter labels; CZNA-1441 removed the column),
 * the record detail and the proposal detail, so the same record does not read as `CZNA`
 * on one screen and `LOCAL` on the next. `sourceSystem` is free text rather than an
 * enum, so anything else — a system this code has never heard of included — passes
 * through untouched.
 */
export var formatSourceSystem = function (value) { return (value === LOCAL_SOURCE_SYSTEM ? LOCAL_SOURCE_SYSTEM_LABEL : value); };
